// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__2k3O5","log":"ModalInventoryLogs_log__27eAo","date":"ModalInventoryLogs_date__1ZqwI","userName":"ModalInventoryLogs_userName__3fHLQ"};